import { useEffect, useRef } from "react";
import { wsUrl } from "@/lib/api";

/** Subscribes to realtime project events. handler receives {event, payload}. */
export function useProjectSocket(projectId, handler) {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!projectId) return undefined;
    let socket;
    let closed = false;
    let retry;

    const connect = () => {
      socket = new WebSocket(wsUrl(projectId));
      socket.onmessage = (event) => {
        try {
          handlerRef.current?.(JSON.parse(event.data));
        } catch (error) {
          console.warn("[socket] malformed frame ignored", error);
        }
      };
      socket.onclose = () => {
        if (!closed) retry = setTimeout(connect, 4000);
      };
    };
    connect();

    return () => {
      closed = true;
      clearTimeout(retry);
      // Avoid "closed before the connection is established" on StrictMode
      // double-invoke: wait for OPEN before closing a CONNECTING socket.
      if (!socket) return;
      if (socket.readyState === WebSocket.CONNECTING) {
        socket.addEventListener("open", () => socket.close());
      } else {
        socket.close();
      }
    };
  }, [projectId]);
}
